import { ListPaginationMeta } from "utils/helpers/pagination";

export type SuperModelManufacturerFilter = string;

export type SuperModelSelectOption = {
  value: string;
  labelKey?: string;
  label?: string;
};

export interface SuperModelManufacturerFilterOption {
  id: number;
  name: string;
}

export interface SuperModelRow {
  superModelId: number;
  superModelName?: string;
  manufacturerId?: number;
  manufacturerName?: string;
  priority: number;
}

export interface SuperModelForm {
  name: string;
  manufacturer: string;
  priority: string;
}

export type SuperModelFormFieldKind = "string" | "number";

export const SUPER_MODEL_FORM_FIELD_KINDS: Record<
  keyof SuperModelForm,
  SuperModelFormFieldKind
> = {
  name: "string",
  manufacturer: "number",
  priority: "number",
};

export type SuperModelListMeta = ListPaginationMeta;

export interface SuperModelListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: SuperModelRow[];
  meta?: SuperModelListMeta;
}

export interface SuperModelUpdate {
  id: number;
  superModelName: string;
  manufacturerId: number;
  priority: number;
}

export interface SuperModelDetailResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: SuperModelRow;
}

export interface SuperModelManufacturerFilterOptionsResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: {
    manufacturers: SuperModelManufacturerFilterOption[];
  };
  meta?: SuperModelListMeta;
}

export type SuperModelFormDropDownState = {
  items: SuperModelManufacturerFilterOption[];
  page: number;
  perPage: number;
  meta: SuperModelListMeta;
  loading: boolean;
};

export interface SuperModelState {
  loading: boolean;
  saving: boolean;
  list: SuperModelRow[];
  page: number;
  perPage: number;
  meta: SuperModelListMeta;
  error: string | null;
  manufacturerFilter: SuperModelManufacturerFilter;
  manufacturerOptions: SuperModelManufacturerFilterOption[];
  manufacturerOptionsLoading: boolean;
  manufacturerOptionsError: string | null;
  isAddModalOpen: boolean;
  form: SuperModelForm;
  formDropDown: SuperModelFormDropDownState;
  detail: SuperModelRow | null;
  detailLoading: boolean;
  detailError: string | null;
}
